import { backendVersion, globalAxios } from "@/axios-path.js";

export default {
  namespaced: true,
  state: {
    package_data: [],
    package_list: []
  },
  mutations: {
    getData(state, data) {
      state.package_data = data;
    },
    getPackageList(state, data) {
      state.package_list = data;
    },
    delPackage(state, data) {
      const index = state.package_list.indexOf(data);
      if (index !== -1) state.package_list.splice(index, 1);
    },
    addPackage(state, data) {
      state.package_list.push(data);
    },
    editPackage(state, { res, original }) {
      const index = state.package_list.indexOf(original);
      if (index !== -1) Object.assign(state.package_list[index], res);
    }
  },
  actions: {
    // Fetch list of packages (stored in package_data) for a specific province
    async getData({ commit }, province) {
      const url = `/api/v1/${province}/show/detail/packages`;
      return globalAxios
        .get(url)
        .then(res => {
          commit("getData", res);
          return res;
        })
        .catch(() => false);
    },
    // Fetch list of packages (stored in package_list) - used in PackageListCard
    async getPackageList({ commit, dispatch }, { province_name }) {
      const url = `/api/v1/${province_name}/show/detail/packages`;
      return globalAxios
        .get(url)
        .then(res => {
          commit("getPackageList", res);
          return res;
        })
        .catch(err => {
          dispatch("disconnectNetwork", err, { root: true });
          return false;
        });
    },
    // Add new package
    async addPackage({ commit }, { form, province }) {
      const url = `/api/v1/${province}/create/package`;
      return globalAxios
        .post(url, form)
        .then(res => {
          if (res === false) return false;
          commit("addPackage", res);
          return res;
        })
        .catch(() => false);
    },
    // Edit existing package
    async editPackage({ commit }, { form, province }) {
      const url = `/api/v1/${province}/edit/package/${form.package_id}`;
      return globalAxios
        .put(url, form)
        .then(res => {
          if (res === false) return false;
          commit("editPackage", { res, original: form });
          return res;
        })
        .catch(() => false);
    },
    // Delete package
    async delPackage({ commit }, { item, province }) {
      const url = `/api/v1/${province}/delete/package/${item.package_id}`;
      return globalAxios
        .delete(url)
        .then(res => {
          if (res === false) return false;
          commit("delPackage", item);
          return true;
        })
        .catch(() => false);
    },
    async getPackageByProvince({ dispatch }, province) {
      const url = `${backendVersion.version}/${province}/show/detail/packages`;
      const res = await dispatch("fetchGeneral/coreInstanceGetData", url, { root: true });
      if (res === false) return false;
      return res;
    }
  },
  getters: {}
};
